import { clsx } from "clsx";

import styles from "./RVLexicalPlaceholder.module.scss";

/** Props for {@link RVLexicalPlaceholder}. */
export interface RVLexicalPlaceholderProps {
    /** The placeholder copy — may contain `\n` for multi-line display. */
    text: string;
    /** Additional CSS class applied to the placeholder wrapper. */
    className?: string;
}

/**
 * Static placeholder overlay for the Lexical editor.
 *
 * Splits `text` on newline characters and renders each line in its own block
 * so that multi-line placeholder text is visually preserved.
 *
 * @example
 * ```tsx
 * <RVLexicalPlaceholder text="Type your message..." />
 * ```
 */
export function RVLexicalPlaceholder({ text, className }: RVLexicalPlaceholderProps) {
    return (
        <div className={clsx(styles.placeholder, className)} data-testid="lexical-placeholder">
            {text?.split("\n").map((line, index) => (
                <div className={styles.line} key={index}>
                    {line}
                </div>
            ))}
        </div>
    );
}
